import React from 'react'
import { Controller } from 'react-hook-form'

import { IUploadImage } from './model'
import CoreUploadImage from './UploadImage'

export const UploadImage = ({ name, mode = 'edit', value = [], onChange, control }: IUploadImage) => {
  // *** Form form-upload-image ***
  if (control) {
    return (
      <Controller
        name={name}
        control={control}
        render={({ onChange: controllerOnChange, value, name }) => {
          return (
            <CoreUploadImage
              value={value}
              name={name}
              mode={mode}
              onChange={fileList => {
                controllerOnChange(fileList)
                onChange && onChange(fileList)
              }}
            />
          )
        }}
      />
    )
  }

  // *** regular form-upload-image ***
  return <CoreUploadImage value={value} name={name} mode={mode} onChange={onChange} />
}
